export class SystemModal {
    constructor(id, readOnly = false, width = 'max-w-lg') {
        this.id = id;
        this.readOnly = readOnly;
        this.width = width;

        // Create the modal container (TailwindCSS and DaisyUI)
        this.modalContainer = document.createElement('div');
        this.modalContainer.className = 'modal w-full'; // DaisyUI modal classes
        this.modalContainer.setAttribute('aria-hidden', 'true');

        // Create the modal content
        this.modalContent = document.createElement('div');
        this.modalContent.className = `modal-box ${this.width}`; // TailwindCSS + DaisyUI box

        // Create the modal header
        this.modalHeader = document.createElement('div');
        this.modalHeader.className = 'flex justify-between items-center pb-4 border-b'; // Header styling

        // Modal title
        this.modalTitle = document.createElement('h2');
        this.modalTitle.className = 'text-lg font-bold'; // Title styling

        // Close button
        this.closeButton = document.createElement('button');
        this.closeButton.type = 'button';
        this.closeButton.className = 'btn btn-sm btn-circle absolute right-2 top-2'; // DaisyUI close button
        this.closeButton.innerHTML = '✕';
        this.closeButton.addEventListener('click', () => this.hide());

        // Append title and close button to header
        this.modalHeader.appendChild(this.modalTitle);
        this.modalHeader.appendChild(this.closeButton);

        // Modal body
        this.modalBody = document.createElement('div');
        this.modalBody.className = 'py-4'; // TailwindCSS body styling

        // Footer for buttons (optional)
        this.modalFooter = document.createElement('div');
        this.modalFooter.className = 'flex justify-end gap-2 pt-4 border-t'; // TailwindCSS footer styling

        // Append the modal content structure
        this.modalContent.appendChild(this.modalHeader);
        this.modalContent.appendChild(this.modalBody);
        this.modalContent.appendChild(this.modalFooter);

        // Append modal content to modal container
        this.modalContainer.appendChild(this.modalContent);

        // Append the modal container to the document body
        document.body.appendChild(this.modalContainer);

        // Bind the custom close handler
        this.closeHandler = () => this.hide();

        // Add click handler to close modal when clicking outside
        this.modalContainer.addEventListener('click', (e) => {
            if (e.target === this.modalContainer) {
                this.hide();
            }
        });
    }

    // Show the modal
    show() {
        this.modalContainer.classList.add('modal-open'); // DaisyUI class to open modal

        // Attach event listener for "closeModal"
        window.addEventListener('closeModal', this.closeHandler);
    }

    // Hide the modal
    hide() {
        this.modalContainer.classList.remove('modal-open');
        window.removeEventListener('closeModal', this.closeHandler);
    }
    

    // Set the title of the modal
    setTitle(title) {
        this.modalTitle.innerText = title;
    }

    // Set the content of the modal
    setContent(content) {
        if (typeof content === 'string') {
            this.modalBody.innerHTML = content;
        } else if (content instanceof HTMLElement) {
            this.modalBody.innerHTML = '';
            this.modalBody.appendChild(content);
        }
    }

    // Render modal with AJAX content
    render() {
        console.log('Rendering modal with ID:', this.id);
        htmx.ajax('GET', `/ui/${this.id}`, {
            target: this.modalBody,
            swap: 'innerHTML'
        });
        this.show();
    }

    // Helper to render modal with static content
    renderWithContent(html) {
        this.setContent(html);
        this.show();
    }
}
